import { showToast } from '../../utils'
export default function (eventData) {
  const { refedId, source } = eventData

  switch (source) {
      case 'component': {
          if (!refedId) {
              console.error('弹框组件 id 未找到', refedId)
              return
          }

          // 找到对应组件
          const elem = document.getElementById(refedId)
          if (elem == null) {
              console.error('id 找不到组件 elem', refedId)
              return
          }
          copy(elem.innerText)
          break
      }
      case 'currentUrl': {
          copy(location.href)
          break
      }
      case 'input': {
          copy(eventData.text)
          break
      }
  }

  showToast('复制成功')
}

/**
* 复制文本
* @param {*} text
*/
function copy (text) {
  const input = document.createElement('input')
  input.readOnly = 'readonly'
  input.style.opacity = 0
  input.value = text
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, input.value.length)
  document.execCommand('Copy')
  document.body.removeChild(input)
}
